var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.config.ui_version==3.0)?_c('HomeConter'):_vm._e(),(_vm.config.ui_version==3.5)?_c('four'):_vm._e(),(_vm.config.ui_version==3.6)?_c('HomeSanDianLiu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }